import { TranslateService } from '@ngx-translate/core';

import { SelectionItem } from '../shared/models/selectionItem';

export interface IgetSelectionItemsOptions {
  sortAlphabetic: boolean;
}

export function getSelectionItems(
  typeEnum: any,
  transpath: string,
  translate: TranslateService,
  options?: IgetSelectionItemsOptions
): SelectionItem[] {
  let selectionItems: SelectionItem[] = [];
  keys(typeEnum)
    .map(key => ({ id: typeEnum[key], name: key }))
    .forEach(item => {
      if (typeof item.name !== 'number') {
        selectionItems.push(
          new SelectionItem(
            item.id,
            translate.instant(transpath + (item.name && item.name[0].toLowerCase() + item.name.slice(1)))
          )
        );
      }
    });
  if (options && options.sortAlphabetic) {
    selectionItems = selectionItems.sort((a, b) => {
      const valueA = a.value.toUpperCase();
      const valueB = b.value.toUpperCase();
      return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
    });
  }
  return selectionItems;
}

function keys(enumType: object) {
  const members = Object.keys(enumType);
  return members.filter(x => Number.isNaN(parseInt(x, 10)));
}
